/* ==========================================================================
   NEOWEAR — Shopify theme interactions
   Uses the real Shopify AJAX Cart API (/cart/add.js, /cart/change.js, /cart.js)
   ========================================================================== */
(function(){
  'use strict';

  const money = (cents, format) => {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || window.themeMoneyFormat || '${{amount}}';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const match = fmt.match(placeholderRegex);
    if (!match) return fmt;

    const defaultTo2 = (n) => {
      const parts = (n / 100).toFixed(2).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    };
    const noDecimals = (n) => Math.round(n / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    let value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = noDecimals(cents);
        break;
      case 'amount':
      default:
        value = defaultTo2(cents);
        break;
    }
    return fmt.replace(placeholderRegex, value);
  };

  document.addEventListener('DOMContentLoaded', () => {

    const header = document.querySelector('.site-header');
    const onScroll = () => { if (header) header.classList.toggle('is-scrolled', window.scrollY > 40); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    const menuToggle = document.querySelector('.menu-toggle');
    const navMain = document.querySelector('.nav-main');
    if (menuToggle && navMain) {
      menuToggle.addEventListener('click', () => navMain.classList.toggle('is-open'));
      navMain.querySelectorAll('a').forEach(a => a.addEventListener('click', () => navMain.classList.remove('is-open')));
    }

    const emailModal = document.getElementById('EmailSignupModal');
    if (emailModal) {
      const openEmailModal = () => {
        emailModal.hidden = false;
        document.body.style.overflow = 'hidden';
      };
      const closeEmailModal = () => {
        emailModal.hidden = true;
        document.body.style.overflow = '';
      };
      document.querySelectorAll('[data-email-modal-open]').forEach(btn => {
        btn.addEventListener('click', openEmailModal);
      });
      emailModal.querySelectorAll('[data-email-modal-close]').forEach(btn => {
        btn.addEventListener('click', closeEmailModal);
      });
      emailModal.addEventListener('click', (e) => {
        if (e.target === emailModal) closeEmailModal();
      });
    }

    document.querySelectorAll('[data-track-guest-form]').forEach(form => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const resultEl = form.querySelector('[data-track-guest-result]');
        if (resultEl) {
          resultEl.textContent = 'Guest order lookup isn\'t connected yet. Please sign in above, or contact us for help with your order.';
          resultEl.style.display = '';
        }
      });
    });

    const announceBar = document.querySelector('.announce-bar');
    if (announceBar) {
      const messages = announceBar.querySelectorAll('.announce-msg');
      let announceIndex = 0;
      const showMessage = (i) => {
        messages.forEach(m => m.classList.remove('is-active'));
        if (messages[i]) messages[i].classList.add('is-active');
      };
      if (messages.length) showMessage(0);

      const nextBtn = announceBar.querySelector('.announce-next');
      const prevBtn = announceBar.querySelector('.announce-prev');
      const goNext = () => { announceIndex = (announceIndex + 1) % messages.length; showMessage(announceIndex); };
      const goPrev = () => { announceIndex = (announceIndex - 1 + messages.length) % messages.length; showMessage(announceIndex); };
      if (nextBtn) nextBtn.addEventListener('click', goNext);
      if (prevBtn) prevBtn.addEventListener('click', goPrev);

      if (messages.length > 1) {
        setInterval(goNext, 5000);
      }
    }

    const refreshCartCount = () => {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(r => r.json())
        .then(cart => {
          document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
        })
        .catch(() => {});
    };

    document.querySelectorAll('form[data-add-to-cart-form]').forEach(form => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        const originalText = btn ? btn.textContent : '';
        if (btn) { btn.textContent = 'Adding…'; btn.setAttribute('disabled', 'disabled'); }

        const formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(async (res) => {
            const data = await res.json();
            if (!res.ok) throw data;
            refreshCartCount();
            if (btn) btn.textContent = 'Added ✓';
            setTimeout(() => {
              if (btn) { btn.textContent = originalText; btn.removeAttribute('disabled'); }
            }, 1600);
          })
          .catch((err) => {
            if (btn) { btn.textContent = err && err.description ? err.description : 'Unavailable'; btn.removeAttribute('disabled'); }
            setTimeout(() => { if (btn) btn.textContent = originalText; }, 2000);
          });
      });
    });

    document.querySelectorAll('[data-product-form]').forEach(root => {
      let productData = {};
      const dataScript = root.querySelector('[data-product-json]');
      if (dataScript) {
        try { productData = JSON.parse(dataScript.textContent); } catch (e) { productData = {}; }
      }
      const variantInput = root.querySelector('input[name="id"]');
      const priceEl = root.querySelector('[data-price]');
      const compareEl = root.querySelector('[data-compare-price]');
      const submitBtn = root.querySelector('[data-submit-button]');
      const stockNote = root.querySelector('[data-stock-note]');
      const optionGroups = root.querySelectorAll('[data-option-index]');

      const getSelectedOptions = () => {
        const selected = [];
        optionGroups.forEach(group => {
          const active = group.querySelector('.active[data-value]');
          selected.push(active ? active.dataset.value : null);
        });
        return selected;
      };

      const findVariant = () => {
        if (!productData.variants) return null;
        const selected = getSelectedOptions();
        return productData.variants.find(v => {
          return v.options.every((opt, i) => selected[i] === null || opt === selected[i]);
        });
      };

      const updateForVariant = (variant) => {
        if (!variant) {
          if (submitBtn) { submitBtn.textContent = 'Unavailable'; submitBtn.setAttribute('disabled', 'disabled'); }
          return;
        }
        if (variantInput) variantInput.value = variant.id;
        if (priceEl) priceEl.textContent = money(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = money(variant.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (submitBtn) {
          if (variant.available) {
            submitBtn.textContent = submitBtn.dataset.defaultText || 'Add to Cart';
            submitBtn.removeAttribute('disabled');
          } else {
            submitBtn.textContent = 'Sold Out';
            submitBtn.setAttribute('disabled', 'disabled');
          }
        }
        if (stockNote) {
          if (variant.available && variant.inventory_quantity !== undefined && variant.inventory_quantity <= 5 && variant.inventory_quantity > 0) {
            stockNote.textContent = `Only ${variant.inventory_quantity} left in stock`;
            stockNote.style.display = '';
          } else {
            stockNote.style.display = 'none';
          }
        }
      };

      optionGroups.forEach(group => {
        group.querySelectorAll('[data-value]').forEach(btn => {
          btn.addEventListener('click', () => {
            group.querySelectorAll('[data-value]').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            updateForVariant(findVariant());
          });
        });
      });

      if (submitBtn && submitBtn.dataset.defaultText === undefined) {
        submitBtn.dataset.defaultText = submitBtn.textContent;
      }
      updateForVariant(findVariant());

      document.querySelectorAll('.pd-thumbs img').forEach(thumb => {
        thumb.addEventListener('click', () => {
          document.querySelectorAll('.pd-thumbs img').forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
          const main = document.querySelector('.pd-gallery-main img');
          if (main) main.src = thumb.dataset.full || thumb.src;
        });
      });

      const qtyBox = root.querySelector('.qty-box');
      if (qtyBox) {
        const input = qtyBox.querySelector('input');
        qtyBox.querySelectorAll('button').forEach(b => {
          b.addEventListener('click', () => {
            let val = parseInt(input.value, 10) || 1;
            val = b.dataset.step === 'down' ? Math.max(1, val - 1) : val + 1;
            input.value = val;
          });
        });
      }

      /* Checkout button: add to cart then jump straight to checkout */
      const buyNowBtn = root.querySelector('[data-buy-now-button]');
      if (buyNowBtn) {
        buyNowBtn.addEventListener('click', () => {
          const form = root.matches('[data-add-to-cart-form]') ? root : root.querySelector('form[data-add-to-cart-form]');
          if (!form) return;
          const originalText = buyNowBtn.textContent;
          buyNowBtn.textContent = 'Processing…';
          buyNowBtn.setAttribute('disabled', 'disabled');

          const formData = new FormData(form);
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData
          })
            .then(async (res) => {
              const data = await res.json();
              if (!res.ok) throw data;
              window.location.href = '/checkout';
            })
            .catch((err) => {
              buyNowBtn.textContent = err && err.description ? err.description : 'Unavailable';
              buyNowBtn.removeAttribute('disabled');
              setTimeout(() => { buyNowBtn.textContent = originalText; }, 2000);
            });
        });
      }
    });

    document.querySelectorAll('[data-sort-select]').forEach(select => {
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        window.location.href = url.toString();
      });
    });

    const filterBar = document.querySelector('[data-filter-bar]');
    if (filterBar) {
      filterBar.querySelectorAll('[data-filter]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          filterBar.querySelectorAll('[data-filter]').forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          const filter = btn.dataset.filter;
          document.querySelectorAll('[data-product-type]').forEach(card => {
            const show = filter === 'all' || card.dataset.productType === filter;
            card.style.display = show ? '' : 'none';
          });
        });
      });
    }

    const cartForm = document.querySelector('[data-cart-form]');
    if (cartForm) {
      const updateSummary = (cart) => {
        document.querySelectorAll('[data-cart-subtotal]').forEach(el => el.textContent = money(cart.total_price));
        document.querySelectorAll('[data-cart-total]').forEach(el => el.textContent = money(cart.total_price));
        document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
      };

      const updateLine = (key, quantity, row) => {
        if (row) row.style.opacity = '0.5';
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        })
          .then(r => r.json())
          .then((cart) => {
            if (cart.item_count === 0 || (quantity === 0 && cart.items.length === 0)) {
              window.location.reload();
              return;
            }
            const updatedItem = cart.items.find(i => i.key === key);
            if (quantity === 0 || !updatedItem) {
              if (row) row.remove();
            } else if (row) {
              row.style.opacity = '';
              const qtyInput = row.querySelector('[data-qty-input]');
              const lineTotal = row.querySelector('[data-line-total]');
              if (qtyInput) qtyInput.value = updatedItem.quantity;
              if (lineTotal) lineTotal.textContent = money(updatedItem.final_line_price);
            }
            updateSummary(cart);
          })
          .catch(() => window.location.reload());
      };

      cartForm.querySelectorAll('[data-qty-increase]').forEach(btn => {
        btn.addEventListener('click', () => {
          const row = btn.closest('[data-line-key]');
          const input = row.querySelector('[data-qty-input]');
          updateLine(row.dataset.lineKey, (parseInt(input.value, 10) || 1) + 1, row);
        });
      });
      cartForm.querySelectorAll('[data-qty-decrease]').forEach(btn => {
        btn.addEventListener('click', () => {
          const row = btn.closest('[data-line-key]');
          const input = row.querySelector('[data-qty-input]');
          updateLine(row.dataset.lineKey, Math.max(0, (parseInt(input.value, 10) || 1) - 1), row);
        });
      });
      cartForm.querySelectorAll('[data-remove-line]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const row = btn.closest('[data-line-key]');
          updateLine(row.dataset.lineKey, 0, row);
        });
      });
    }

    const params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') === 'true') {
      document.querySelectorAll('[data-form-success]').forEach(el => { el.style.display = ''; });
    }
    if (params.get('contact_posted') === 'true') {
      document.querySelectorAll('[data-contact-success]').forEach(el => { el.style.display = ''; });
    }

  });
})();